import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home',
    },
    {
        id: 88,
        title: 'About',
        link: '/about',
    },
    {
        id: 3,
        title: 'Products',
        submenu: [
            {
                      id: 31,
                      title: '3 Layer Water Tank',
                      link: '/tank3',
                    },
                     {
                      id: 312,
                      title: '6 Layer Water Tank',
                      link: '/tank6',
                    },
                     {
                      id: 313,
                      title: '10 Layer Water Tank ',
                      link: '/tank10',
                    },
                     {
                      id: 314,
                      title: '6 Layer Loft Water Tank',
                      link: '/tanklayer6',
                    },
            {
                id: 32,
                title: 'PP Fabric',
                link: '/ppFabric',
            },
            {
                id: 33,
                title: 'PP Woven Bag',
                link: '/wovenBag',
            },
            {
                id: 34,
                title: 'BOPP Multicolor Bag',
                link: '/multicolorBag',
            },
            {
                id: 35,
                title: 'PP Laminated  Craft Paper Bag',
                link: '/craftPaperBag',
            },
            {
                id: 36,
                title: 'Leno Bag',
                link: '/lenoBag',
            },
            {
                id: 37,
                title: 'Corrugated Box',
                link: '/corrugatedBox',
            },
           
        ]
    },
    {
        id: 44,
        title: 'Machinery',
        link: '#',

    },
    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    }


]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;